const state = { pendingLength: 0 };
const mutations = {
  SETPENDINAG: (state, num) => {
    state.pendingLength += num;
  }
};
const actions = {
  loading({ commit }, num) {
    commit('SETPENDINAG', num);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
